/* Load a YouTube iframe only after a click or tap on the poster.
   No IntersectionObserver and no autoplay until that click. */
(function () {
  function withAutoplay(src) {
    if (/[?&]autoplay=/.test(src)) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
  }

  document.addEventListener(
    'click',
    function (event) {
      var root = event.target && event.target.closest ? event.target.closest('[data-youtube-click]') : null;
      if (!root || root.querySelector('iframe')) return;

      var src = root.getAttribute('data-youtube-src');
      if (!src) return;

      event.preventDefault();

      var article = root.querySelector('article') || root;
      var iframe = document.createElement('iframe');
      iframe.src = withAutoplay(src);
      iframe.title = root.getAttribute('data-youtube-title') || 'Video';
      iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;background:#000;';
      article.appendChild(iframe);

      var button = root.querySelector('button');
      if (button) button.hidden = true;
    },
    true
  );
})();
